import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { fetchAccountConsent_ac } from '../../actions/account_in_view.ac';
// import Loader from '../Shared/Loader';
import { WidgetContainer } from '../Widgets/index.js';

const ConsentWidgetContainer = (props) => {
  const { account, member, onConsentUpdate, v_id } = props;

  const handleWidgetEvent = (widgetName, eventType, eventData) => {
    // console.log('Widget event received:', { widgetName, eventType, eventData });
    if (eventType === 'consent_data_updated') {
      // Handle consent data updates
      // console.log('Consent updated for:', eventData.account, eventData.member);
      if (onConsentUpdate) {
        onConsentUpdate(eventData.consentData.consent_record);
      }
    }
  };

  return (
    <WidgetContainer
      widgetName="consent_management"
      widgetProps={{ account, member, v_id }}
      onWidgetEvent={handleWidgetEvent}
      // autoFullHeight={true}
      style={{
        //make it be the whol width and height of the parent
        // width: '98%',
        marginTop: '10px',
        marginBottom: '10px',
        boxShadow: 'none',
        // height: 'calc(56vh - 2px)',
      }}
    />
  );
};

// const COLOR_REF = [
//   ['red', '#fff'],
//   ['red', '#fff'],
//   ['yellow', '#000'],
//   ['yellow', '#000'],
//   ['lightgreen', '#000'],
// ];

const ConsentLauncherButton = (props) => {
  // const [isCleared, setIsCleared] = useState(false);
  const [currentConsentRecord, setCurrentConsentRecord] = useState(null);
  const {
    onConsentActivityClearanceDetermined,
    // accountConsent,
    flow_record_id,
    accountMember,
    // onClick,
    // disabled,
    // fetchAccountConsent_ac,
  } = props;

  const [account, member] = accountMember
    ? accountMember.split('-')
    : [null, null];

  // const {
  //   consentRecord: consentRecordOrig,
  //   isFetching: isFetchingConsentRecord,
  //   reference,
  // } = accountConsent;

  // useEffect(() => {
  //   setCurrentConsentRecord(consentRecordOrig);
  // }, [consentRecordOrig]);

  useEffect(() => {
    if (!currentConsentRecord) {
      if (onConsentActivityClearanceDetermined) {
        onConsentActivityClearanceDetermined(false);
      }
      return;
    }
    const email = currentConsentRecord.mode_email
      ? currentConsentRecord.mode_email.value
      : null;
    const sms = currentConsentRecord.mode_sms
      ? currentConsentRecord.mode_sms.value
      : null;

    // const { aob_status } = currentConsentRecord;

    let markAsCleared = email || sms;
    // (email || sms) && aob_status && aob_status.aob_cleared === true;
    // Per Jesus - we are not going to consider aob_status for now

    // debugger;
    // setIsCleared(markAsCleared);
    if (onConsentActivityClearanceDetermined) {
      console.log({
        msg: 'inside CLB useEffect',
        markAsCleared,
        email,
        sms,
      });
      onConsentActivityClearanceDetermined(markAsCleared);
    }
  }, [onConsentActivityClearanceDetermined, currentConsentRecord]);

  const handleConsentUpdate = (newConsentRecord) => {
    setCurrentConsentRecord(newConsentRecord);
  };

  // if (isFetchingConsentRecord || !currentConsentRecord) {
  //   return <Loader />;
  // }

  // debugger;
  // if (isCleared) {
  //   return <div>Consent cleared</div>;
  // }
  return (
    <ConsentWidgetContainer
      account={account}
      member={member}
      v_id={flow_record_id}
      onConsentUpdate={handleConsentUpdate}
    />
  );
};

const mapStateToProps = (state) => ({
  me: state.me,
  accountConsent: state.accountConsent,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // fetchAccountConsent_ac,
    },
    dispatch
  );

const ConnectedConsentLauncherButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsentLauncherButton);

export { ConnectedConsentLauncherButton, ConsentWidgetContainer };
